import { Sidebar as DemostackSidebar } from '@carboncopyco/ui';
import type React from 'react';
import { SidebarButton } from './SidebarButton';
import { SidebarSeparator } from './SidebarSeparator';

export interface SidebarProps
  extends Pick<React.HTMLAttributes<'div'>, 'aria-label'> {
  children?: React.ReactNode;
}

export const Sidebar = ({ children, ...props }: SidebarProps) => {
  return (
    <div
      className="h-full w-ds-15"
      role="toolbar"
      {...props}
    >
      <DemostackSidebar>
        <div className="flex flex-col items-center gap-2.5 pt-5 pb-4 h-full">
          {children}
        </div>
      </DemostackSidebar>
    </div>
  );
};

Sidebar.Button = SidebarButton;
Sidebar.Separator = SidebarSeparator;
